<template>
    <div id="userProfilePage" :class="'popupPage anim'+ ( open ? ' open' : '' )">
        <div v-if="user != null && open" class="container h-100">
            <div class="row h-100">
                <div class="col-md-6 h-100 m-auto pb-4 d-flex flex-column">
                    <div class="header">
                        <a @click.prevent="open = false;btnSfx();" href="#" class="close"></a>
                    </div>
                    <div class="row mb-2 vh-50">
                        <div :class="'text-center pt-4 pr-0 p-lg-0 col-12'+(user.mtsCustomerCategory ? ' profileImageMts-'+user.mtsCustomerCategory.name:'')">
                            <a href="#" @click.prevent="setAvatar(); btnSfx();" class="profileImage"><img :src="user.avatarUrl !== undefined ? user.avatarUrl : '/images/male-default.png'"/></a>
                            <div class="mt-2">
                                <a href="https://adbaloo.mobi/loyalty-info/mts" target="_blank">
                                    <b-badge v-if="user.mtsCustomer" class="p-2">{{ user.mtsCustomerCategory.friendlyName || user.mtsCustomerCategory.name }}</b-badge>
                                </a>
                            </div>
                            <h3 class="text-break py-3">{{ user.username }}</h3>
                        </div>
                        <ul @click="$emit('changeTab','shop-tab');btnSfx();hide();" class="profileInfo">
                            <li class="row">
                                <div class="col-6">
                                    <img src="/images/joker.png"/> {{ user.jokers }}
                                </div>
                                <div class="col-6">
                                    <img src="/images/dandelion.png"/> {{ user.swappers || 0 }}
                                </div>
                            </li>
                            <li class="row">
                                <div class="col-12">
                                    <img src="/images/token.png"/> {{ user.tokens || 0 }}
                                </div>
                            </li>
                            <li class="row">
                                <div class="col-12">
                                    <img src="/images/diamond.png"/> {{ user.diamonds || 0}}
                                </div>
                            </li>
                            <li v-if="user.mtsCustomer" class="row">
                                <div class="col-12">
                                    <img src="/images/rubins.png"/> {{ user.mtsCustomerPoints || 0 }}
                                </div>
                            </li>
                        </ul>
                        <div class="d-flex flex-column justify-content-end col-12 px-5 py-4">
                            <div class="pr-4 pl-4 pt-2">
                                <b-button @click="$emit('changeTab','settings');btnSfx();" variant="yellow" class="btn-block text-left mb-3" ><i class="fas fa-cog mr-2"></i> {{ $t('profile.settings_popup_title') }}</b-button>
                                <b-button @click="$emit('changeTab', 'news');btnSfx();" variant="success" class="btn-block text-left mb-3" ><i class="far fa-newspaper mr-2"></i> {{ $t('profile.news_btn') }}</b-button>
                                <b-button v-if="!user.mtsCustomer && config.mtsCustomerConnectionsEnabled" @click="openMtsCustomerPopup();btnSfx();" variant="primary" class="btn-block text-left mb-3" ><img src="/images/theme/mts/bear/male-default.png" alt="Connect MTS account" height="25" class="mr-2"/> {{ $t('base.btn_connect_loyalty') }}</b-button>
                                <b-button v-if="!!user.mtsCustomer ? settings.supportEnabled : config.supportEnabled" @click="openSupportPopup();btnSfx();" variant="purple" class="btn-block text-left mb-3" ><img src="/images/icon-support.png" alt="Support icon" height="25" class="mr-2"/> {{ $t('base.btn_support') }}</b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <avatar-popup ref="avatarPopup"></avatar-popup>
            <support-popup ref="supportPopup"></support-popup>
            <mts-customer-popup ref="mtsCustomerPopup"></mts-customer-popup>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import api from '../../api'
import AvatarPopup from '../AvatarPopup.vue'
import MtsCustomerPopup from './MtsCustomerPopup.vue'
import SupportPopup from './SupportPopup.vue'


const UserProfile = Vue.component('user-profile', {
    components: {
        AvatarPopup, SupportPopup, MtsCustomerPopup
    },
    data() {
        return {
            open: false,
            settings: null
        }
    },
    computed: {
        user() {
            return this.$store.state.auth.user;
        },
        config(){
            return this.$store.state.config.data;
        }
    },
    methods:{

        btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },

        show(tab) {
            let $this = this;

            let loader = document.getElementById('loader');
            loader.classList.add("show");

            api.settings()
                .then(response => {
                    $this.settings = response.data;
                    $this.open = true;
                })
                .catch(error => {
                    api.baseErrorHendler(error);
                })
                .then(res => {
                    loader.classList.remove("show");
                })
        },
        
        hide() {
            this.open = false;
        }, 

        setAvatar(){
            this.$refs.avatarPopup.show();
        },

        openSupportPopup(){
            this.$refs.supportPopup.show();
        },

        openMtsCustomerPopup(){
            this.$refs.mtsCustomerPopup.show();
        },

    },

    beforeDestroy(){
        document.getElementById('loader').classList.remove("show");
    },

    watch: {
        open(){
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            document.body.scrollTop = 0; // For Safari
            if(this.open) document.body.classList.add("lock");
            else document.body.classList.remove("lock");
        },
    }
    
})

export default UserProfile
</script>